export var IssueType;
(function (IssueType) {
    IssueType["ALARM"] = "measuredDataAlarm";
    IssueType["SOURCE_OFFLINE"] = "sourceOffline";
    IssueType["DEVICE_OFFLINE"] = "deviceOffline";
    IssueType["LOW_BATTERY"] = "lowBattery";
})(IssueType || (IssueType = {}));
export const ISSUE_STATES = {
    OK: {
        id: 0,
        name: 'fine',
        class: 'is-success'
    },
    ACKNOWLEDGED: {
        id: 0,
        name: 'acknowledged',
        class: 'is-success'
    },
    OFF_SOURCE: {
        id: 1,
        name: IssueType.SOURCE_OFFLINE,
        class: 'is-grey'
    },
    OFF_DEVICE: {
        id: 1,
        name: IssueType.DEVICE_OFFLINE,
        class: 'is-grey'
    },
    LOW: {
        id: 2,
        name: IssueType.LOW_BATTERY,
        class: 'is-warning'
    },
    WARN: {
        id: 3,
        name: IssueType.ALARM,
        alarmLevel: 'Warning',
        class: 'is-warning'
    },
    ALARM: {
        id: 4,
        name: IssueType.ALARM,
        alarmLevel: 'Alarm',
        class: 'is-danger'
    },
    DISABLED: {
        id: 5,
        name: 'disabled',
        class: 'is-dep-disabled'
    }
};
export function getIssueTypes() {
    return Object.values(IssueType);
}
